export const PAGE_SIZE_OPTIONS = ['10', '25', '50', '100', '200', '500']
